import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  computed: {
    ...mapGetters({
      cart: 'checkout/cart',
      simpleCart: 'checkout/simpleCart',
      isCartLoading: 'checkout/isCartLoading',
      totals: 'checkout/totals',
      isTotalsLoading: 'checkout/isTotalsLoading',
    }),
    showTotals() {
      return !_.isEmpty(this.totals) && !!this.cart.length;
    },
    totalQty() {
      return this.cart.reduce(
        (totalItems, product) => totalItems + parseInt(product.CartItem.Quantity, 10),
        0,
      );
    },
    isCheckoutAllowed() {
      return !this.isCartLoading && !!this.cart.length;
    },
    isOneOfProductUnavailable() {
      return !!_.find(this.cart, element => element.Product.Price <= 0);
    },
  },
  methods: {
    addItemAndOpenCart(data) {
      this.addItemToCart(data).then(() => {
        this.fetchSimpleCart();
      });
    },
    ...mapActions({
      fetchCart: 'checkout/fetchCart',
      fetchSimpleCart: 'checkout/fetchSimpleCart',
      fetchTotals: 'checkout/fetchTotals',
      clearCart: 'checkout/clearCart',
      addItemToCart: 'checkout/addItemToCart',
      deleteCartItem: 'checkout/deleteCartItem',
      updateCartItem: 'checkout/updateCartItem',
    }),
  },
};
